<style scoped>
.question-item-wrapper {
  padding: 10px;
}
.video-player {
  width: 50%;
}
.padding-top-8 {
  padding-top: 8px;
}
.margin-left-10 {
  margin-left: 10px;
}
.mu-input {
  padding-bottom: 0px;
}
.mu-card-text {
  padding-top: 0px;
}
</style>

<template>

<div class="question-item-wrapper">
  <mu-paper :z-depth="1">
    <mu-card-header class="display-flex">
      <div class="flex-item drag-handle">
        <div class="wordwrap item-title">{{question.content}}</div>
        <mu-button icon small @click.stop.prevent="collapsed = !collapsed" v-if="question.type === 'mc'" >
          <mu-icon :value="collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'" />
        </mu-button>
        <mu-button icon small @click.stop.prevent="flagDialogEdit = true" v-tooltip="$t('button.edit')">
          <mu-icon value="edit"/>
        </mu-button>
        <mu-button icon small @click.stop.prevent="flagDialogDelete = true" v-tooltip="$t('button.delete')">
          <mu-icon value="delete"/>
        </mu-button>
        <mu-button icon small @click.stop.prevent="onActionClone" v-tooltip="$t('button.clone')">
          <mu-icon value="file_copy"/>
        </mu-button>
      </div>
      <div>
        <small>{{tooltipType}}</small>
        <div v-if="question.type === 'mc'">
          <small v-if="question.rand_order" >{{$t('question.randOrderTrue')}}</small>
          <small v-else >{{$t('question.randOrderFalse')}}</small>
        </div>
        <small v-if="question.timestamp !== -1">
          {{$t('question.embedded') + stringTimeFormatter(question.timestamp)}} ({{$t('question.timestampMsg')}})
        </small>
      </div>
    </mu-card-header>
    <mu-card-text v-if="question.type === 'mc' && !collapsed">
      <div v-if="answers.length">
        <draggable :list="answers" @change="onChangeOrder" :options="{handle:'.drag-handle'}">
          <transition-group name="list">
            <div v-for="(answer, index) in answers" :key="index">
              <mu-flex class="flex-wrapper" justify-content="center">
                <mu-flex class="flex-wrapper padding-top-8" justify-content="center">
                  <mu-checkbox
                    v-model="modelAnswer"
                    :value="answer._id"
                    @change="onActionEditCorrect"
                    v-if="question.multi_select"
                    class="vertical-align-middle"
                    />
                  <mu-radio
                    v-model="modelAnswerSingle"
                    :value="answer._id"
                    @change="onActionEditCorrect"
                    class="vertical-align-middle"
                    v-else
                    />
                </mu-flex>
                <answer-item :answer="answer" @onUpdateAnswer="onUpdateAnswer" class="margin-left-10"/>
              </mu-flex>
            </div>
          </transition-group>
        </draggable>
        <mu-flex class="flex-wrapper" justify-content="center">
          <mu-button flat @click.stop.prevent="onClickCreateAns" v-if="isAnswerShow" color="primary">
            <mu-icon value="add"/> {{$t('button.add') + $t('space') + $t('answer.title')}}
          </mu-button>
        </mu-flex>
      </div>
      <div v-else>{{$t('question.noAnswer')}}</div>
    </mu-card-text>
    <LTIForm
      v-if="question.type == 'turnitin'"
      :data="dataLTI"
      service="turnitin"
      />
  </mu-paper>
  <mu-dialog :title="$t('button.edit') + $t('space') + $t('question.title')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogEdit">
    <mu-form :model="form">
      <mu-row gutter>
        <mu-col span="12">
          <mu-form-item prop="input" :label="$t('question.title')">
            <mu-text-field v-model="modelContent" multi-line :rows="3" full-width></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="input" :label="$t('question.prompt')">
            <mu-text-field v-model="modelPrompt" multi-line :rows="3" full-width></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="radio">
            <mu-radio v-model="modelType" value="mc" :label="$t('question.mc')"></mu-radio>
            <mu-radio v-model="modelType" value="open" :label="$t('question.open')"></mu-radio>
            <mu-radio v-model="modelType" value="file" :label="$t('question.file')"></mu-radio>
            <mu-radio v-model="modelType" value="turnitin" :label="$t('question.turnitin')"></mu-radio>
          </mu-form-item>
          <div v-if="modelType == 'mc'">
            <mu-form-item prop="checkbox">
              <mu-checkbox v-model="modelMultiSelect" :label="$t('question.multiSelect')"></mu-checkbox>
              <mu-checkbox v-model="modelRandOrder" :label="$t('question.randOrder')"></mu-checkbox>
            </mu-form-item>
          </div>
          <div v-if="media.type == 'video' || media.type == 'youtube' || media.type == 'mp4link'" class="md-layout-item md-size-50 md-small-size-100">
            <mu-form-item prop="radio">
              <mu-radio v-model="modelTimestampUse" :value="constTrue" :label="$t('question.timestampTrue')"></mu-radio>
              <mu-radio v-model="modelTimestampUse" :value="constFalse" :label="$t('question.timestampFalse')"></mu-radio>
            </mu-form-item>
            <div v-if="modelTimestampUse">
              <div>{{$t('question.timestampMsg')}}</div>
              <video-player
                class="vjs-default-skin video-player"
                ref="videoPlayer"
                :options="playerOptions"
                :playsinline="true"
                @play="onPlayerPlay($event)"
                @pause="onPlayerPause($event)"
                @ended="onPlayerEnded($event)"
                @loadeddata="onPlayerLoadeddata($event)"
                @waiting="onPlayerWaiting($event)"
                @playing="onPlayerPlaying($event)"
                @timeupdate="onPlayerTimeupdate($event)"
                @canplay="onPlayerCanplay($event)"
                @canplaythrough="onPlayerCanplaythrough($event)"
                @ready="playerReadied"
                @statechanged="playerStateChanged($event)">
              </video-player>
              <VueSlider
                v-model="modelTimestamp"
                v-bind="sliderOptions"
                />
            </div>
          </div>
        </mu-col>
      </mu-row>
    </mu-form>
    <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionEdit" :disabled="isContentEmpty"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
  <mu-dialog :title="$t('button.add') + $t('space') + $t('answer.title')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogCreateAns">
    <mu-form :model="form" label-width="500">
      <mu-form-item prop="input" :label="$t('answer.title')">
        <mu-text-field v-model="modelContentAns" multi-line :rows="2" full-width></mu-text-field>
      </mu-form-item>
    </mu-form>
    <mu-button slot="actions" flat color="primary" @click="onActionCancelAns"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionCreateAns" :disabled="isContentAnsEmpty"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
  <mu-dialog :title="$t('button.delete') + $t('space') + $t('question.title')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogDelete">
    {{stringDelete}}
    <mu-button slot="actions" flat color="primary" @click="flagDialogDelete = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionDelete"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
</div>

</template>

<script>
// Components
import AnswerItem from '@/components/Quiz/AnswerItem.vue'
import LTIForm from '@/components/Common/LTIForm'

// Utils
import timeFormatter from '@/utils/timeFormatter.js'

// Library
import axios from "axios";
import draggable from 'vuedraggable'
import VueSlider from 'vue-slider-component';

export default {
  name: 'QuestionItem',
  components: {
    AnswerItem, LTIForm, draggable, VueSlider
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    media: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      // Object
      answers: [], // Answers object
      form: {},
      collapsed: true,

      // Flag
      flagFetchedAnswer: false, // Boolean variable for fetched answer
      flagDialogEdit: false, // Boolean variable for status of edit dialog
      flagDialogDelete: false, // Boolean variable for status of delete dialog
      flagDialogCreateAns: false, // Boolean variable for status of Add dialog
      flagDialogTimestamp: false, // Boolean variable for status of timestamp dialog

      // Model
      modelContent: this.question.content, // Bind with content input
      modelPrompt: this.question.prompt, // Bind with prompt input
      modelType: this.question.type, // Bind with type of file
      modelAnonymous: this.question.anonymous, // Bind with anonymous input
      modelMultiSelect: this.question.multi_select, // Bind with multi_select input
      modelRandOrder: this.question.rand_order, // Bind with rand_order input
      modelContentAns: "", // Bind with content answer input
      modelTimestamp: this.question.timestamp, // Bind with anonymous input
      modelTimestampList: 0,
      modelAnswer: this.question.correct, // Bind with answer input

      // Video.js
      ready: false,
      playerOptions: { // Options for player
        autoplay: this.$store.state.autoPlay,
        language: this.$i18n.locale(),
        playbackRates: [1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: "",
        }],
        poster: "",
        fluid: true,
        controlBar: {
          volumePanel: {
            inline: false
          },
          fullscreenToggle: false
        },
      },
      duration: 0,
      currentTime: 0,

      sliderOptions: {
        data: null,
        eventType: 'auto',
        width: 'auto',
        height: 6,
        dotSize: 16,
        dotHeight: null,
        dotWidth: null,
        min: 0,
        max: this.media.duration,
        interval: 1,
        show: true,
        speed: 0.5,
        disabled: false,
        piecewise: false,
        usdKeyboard: false,
        enableCross: true,
        piecewiseStyle: false,
        piecewiseLabel: false,
        tooltip: 'hover',
        tooltipDir: 'top',
        reverse: false,
        data: null,
        clickable: true,
        realTime: false,
        lazy: false,
        formatter: this.stringTimeFormatter,
        bgStyle: null,
        sliderStyle: null,
        processStyle: null,
        piecewiseActiveStyle: null,
        piecewiseStyle: null,
        tooltipStyle: null,
        labelStyle: null,
        labelActiveStyle: null
      }
    }
  },
  watch: {
    currentTime(newValue) {
      if(this.player.seeking())
      this.modelTimestamp = newValue;
    },
    triggerRefresh() {
      this.fetchAnswers();
      this.ready = false;
      if(this.media.type === "video") {
        this.playerOptions.sources[0].src = this.stringSource;
      } else if(this.media.type === "youtube") {
        this.playerOptions.sources[0].src = "//www.youtube.com/watch?v=" + this.media.content;
        this.playerOptions.sources[0].type = "video/youtube";
        this.playerOptions.techOrder = ["youtube"];
      } else if(this.media.type === "mp4link") {
        this.playerOptions.sources[0].src = this.media.content;
        this.playerOptions.sources[0].type = "video/mp4";
        this.playerOptions.techOrder = ["html5"];
      }
      this.ready = true;
    },
  },
  computed: {
    // Flag
    isContentEmpty() {
      if (this.modelContent === "") {
        return true;
      } else {
        return false;
      }
    },
    isContentAnsEmpty() {
      if (this.modelContentAns === "") {
        return true;
      } else {
        return false;
      }
    },
    isAnswerShow() {
      return this.question.type === 'mc'
    },

    // String
    stringDelete() {
      return this.$t('prompt.deleteMsg', { name: this.modelContent });
    },
    stringSource() {
      return this.media.content;
    },

    // Video.js
    player() { // Return player instance
      return this.$refs.videoPlayer.player
    },

    // Store
    autoPlay() {
      return this.$store.state.autoPlay;
    },

    // Constant
    constTrue() {
      return true;
    },
    constFalse() {
      return false;
    },

    // Model
    modelTimestampUse: {
      get() {
        if(this.modelTimestamp == -1)
          return false;
        else
          return true;
      },
      set(newValue) {
        if(!newValue)
          this.modelTimestamp = -1;
        else
          this.modelTimestamp = 0;
      }
    },
    modelAnswerSingle: {
      get() {
        if(this.modelAnswer.length > 0)
          return this.modelAnswer[0];
        else
          return "";
      },
      set(newValue) {
        this.modelAnswer = [newValue];
      }
    },

    // Object
    dataLTI() {
      return {
        'context_id': this.question.media_id,
        'resource_link_id': this.question._id,
        'resource_link_title': this.question.content,
        'resource_link_description': this.question.type,
        'roles': "Instructor"
      };
    },

    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },

    // Tooltip
    tooltipType() {
      if(this.question.type === 'mc') {
        var str = this.$t('question.mc');
        if(this.question.multi_select) {
          str += ' (' + this.$t('question.multiSelectTrue') + ')';
        } else {
          str += ' (' + this.$t('question.multiSelectFalse') + ')';
        }
        return str;
      } else {
        return this.$t('question.' + this.question.type);
      }
    }
  },
  mounted() {
    this.fetchAnswers();
    this.ready = false;
    if(this.media.type === "video") {
      this.playerOptions.sources[0].src = this.stringSource;
    } else if(this.media.type === "youtube") {
      this.playerOptions.sources[0].src = "//www.youtube.com/watch?v=" + this.media.content;
      this.playerOptions.sources[0].type = "video/youtube";
      this.playerOptions.techOrder = ["youtube"];
    } else if(this.media.type === "mp4link") {
      this.playerOptions.sources[0].src = this.media.content;
      this.playerOptions.sources[0].type = "video/mp4";
      this.playerOptions.techOrder = ["html5"];
    }
    this.ready = true;
  },
  methods: {
    // Fetch
    fetchAnswers() {
      axios.get(this.$store.getters.urlApi + "answer/question/" + this.question._id, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        if(response.data.data.answers)
          this.answers = response.data.data.answers;
        this.flagFetchedAnswer = true;
      });
    },

    // Event
    onUpdateAnswer() {
      this.fetchAnswers();
    },
    onEditQuestion() {
      this.flagDialogEdit = true;
    },
    onActionEdit() {
      this.flagDialogEdit = false;
      axios.put(this.$store.getters.urlApi + "question/" + this.question._id, {
        'content': this.modelContent,
        'prompt': this.modelPrompt,
        'type': this.modelType,
        'anonymous': this.modelAnonymous,
        'multi_select': this.modelMultiSelect,
        'rand_order': this.modelRandOrder,
        'timestamp': Math.floor(this.modelTimestamp),
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    onActionEditCorrect() {
      axios.put(this.$store.getters.urlApi + "question/" + this.question._id, {
        'correct': this.modelAnswer
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      );
    },
    onClickDelete(question) {
      this.flagDialogDelete = true;
      this.question_id_now = question._id;
    },
    onActionDelete() {
      this.flagDialogDelete = false;
      axios.delete(this.$store.getters.urlApi + "question/" + this.question._id, {
        headers: {
          token: this.$store.state.auth.token
        },
        params: {
          'ids': this.attachmentIds
        }
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.delete'));
        this.$emit('onDelete');
      });
    },
    onActionCancel() {
      this.flagDialogEdit = false;
      this.modelContent = this.question.content;
      this.modelType = this.question.type;
      this.modelAnonymous = this.question.anonymous;
    },
    onClickCreateAns() {
      this.flagDialogCreateAns = true;

      this.modelContentAns = "";
    },
    onActionCreateAns() {
      this.flagDialogCreateAns = false;

      let formData = new FormData();
      formData.append('content', this.modelContentAns);
      axios.post(this.$store.getters.urlApi + "answer/question/" + this.question._id, formData, {
        headers: {
          token: this.$store.state.auth.token
        },
        }
      ).then(() => {
        this.onUpdateAnswer();
        this.$toast.success(this.$t('toast.create'));
      });
    },
    onActionCancelAns() {
      this.flagDialogCreateAns = false;
    },
    onChangeOrder() {
      axios.put(this.$store.getters.urlApi + "answer", {
        'data': this.answers
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      );
    },
    onActionClone() {
      axios.post(this.$store.getters.urlApi + "question/" + this.question._id, {}, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.clone'));
      });
    },

    // Video.js
    onPlayerPlay(player) {
      this.duration = player.duration();
    },
    onPlayerPause() {

    },
    onPlayerEnded() {

    },
    onPlayerLoadeddata() {

    },
    onPlayerWaiting() {

    },
    onPlayerPlaying() {

    },
    onPlayerTimeupdate(player) {
      this.currentTime = player.currentTime();
    },
    onPlayerCanplay() {

    },
    onPlayerCanplaythrough() {

    },
    playerStateChanged() {

    },
    playerReadied() {

    },

    stringTimeFormatter(value) {
      return timeFormatter(value);
    },
  },

}
</script>
